import { render, staticRenderFns } from "./menuRrhh.vue?vue&type=template&id=2e0dc8cc&scoped=true"
import script from "./menuRrhh.vue?vue&type=script&lang=js"
export * from "./menuRrhh.vue?vue&type=script&lang=js"
import style0 from "./menuRrhh.vue?vue&type=style&index=0&id=2e0dc8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0dc8cc",
  null
  
)

export default component.exports